module.exports = __webpack_public_path__ + "static/12-f62d7571154c440c62edc208d875a9c6.jpg";